import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { Documento, IDocumento } from '@/shared/model/seguimiento/administrativo/documento.model';
import { Beca, IBeca } from '@/shared/model/seguimiento/beca.model';
import { TipoSolicitudCarta } from '@/shared/model/exbecarios/tipo-solicitud-carta.model';
import { EventoCartaConclusion, IEventoCartaConclusion } from '@/shared/model/exbecarios/evento-carta-conclusion.model';
import resolveEstadoSolicitudVariant from '@/shared/estados/estados.solicitud.util';
import { TipoCartaConclusion } from '@/shared/model/enumerations/tipo-carta-conclusion.model';
import { RetribucionSocial } from './retribucion-social.model';

export interface ICartaConclusion {
  id?: string | null;
  tipo?: TipoCartaConclusion | null;
  tipoSolicitudCarta?: TipoSolicitudCarta | null;
  eventos?: EventoCartaConclusion[] | null;
  estadoActual?: EstadoSolicitud | null;
  institucion?: string | null;
  programa?: string | null;
  documentos?: Documento[] | null;
  beca?: Beca | null;
  variant?: string | null;
  trabajoTerminal?: TrabajoTerminal;
  constanciaRetribucionSocial?: ConstanciaRetribucionSocial;
  cvuBecario?: string;
  sustentoSolicitud?: ISustentoSolicitud | null;
  tipoSolucion?: string | null;
}

export class CartaConclusion implements ICartaConclusion {
  constructor(
    public id?: string | null,
    public tipo?: TipoCartaConclusion | null,
    public tipoSolicitudCarta?: TipoSolicitudCarta | null,
    public eventos?: EventoCartaConclusion[] | null,
    public estadoActual?: EstadoSolicitud,
    public institucion?: string | null,
    public programa?: string | null,
    public documentos?: Documento[] | null,
    public beca?: Beca | null,
    public variant?: string | null,
    public uriCarta?: string | null,
    public trabajoTerminal?: TrabajoTerminal,
    public constanciaRetribucionSocial?: ConstanciaRetribucionSocial,
    public cvuBecario?: string,
    public sustentoSolicitud?: ISustentoSolicitud | null,
    public tipoSolucion?: string | null
  ) {
    this.documentos = documentos ?? [];
    this.eventos = eventos ?? [];
    this.beca = beca ?? new Beca();
    this.trabajoTerminal = trabajoTerminal ?? new TrabajoTerminal();
    this.constanciaRetribucionSocial = constanciaRetribucionSocial ?? new ConstanciaRetribucionSocial();
  }

  static fromObject(data: ICartaConclusion): CartaConclusion {
    const transformations = {
      eventos: (eventos: IEventoCartaConclusion[]) => eventos.map(EventoCartaConclusion.fromObject),
      documentos: (documentos: IDocumento[]) => documentos.map(Documento.fromObject),
      beca: (beca: IBeca) => Beca.fromObject(beca),
      trabajoTerminal: (trabajoTerminal: TrabajoTerminal) => TrabajoTerminal.fromObject(trabajoTerminal),
      constanciaRetribucionSocial: (constanciaRetribucionSocial: ConstanciaRetribucionSocial) =>
        ConstanciaRetribucionSocial.fromObject(constanciaRetribucionSocial),
      sustentoSolicitud: (sustentoSolicitud: SustentoSolicitud) => new SustentoSolicitud(sustentoSolicitud),
    };

    const cartaConclusion = new CartaConclusion();
    for (const [key, value] of Object.entries(data)) {
      const transform = transformations[key as keyof ICartaConclusion];
      cartaConclusion[key] = transform ? transform(value) : value;
    }
    cartaConclusion.variant = resolveEstadoSolicitudVariant(cartaConclusion?.estadoActual);
    return cartaConclusion;
  }
}
export interface ITrabajoTerminal {
  descripcion?: string;
  disponibleEnLinea?: boolean;
  urlEnLinea?: string;
}
export class TrabajoTerminal implements ITrabajoTerminal {
  constructor(public descripcion?: string, public disponibleEnLinea?: boolean, public urlEnLinea?: string) {}

  static fromObject(item: ITrabajoTerminal): TrabajoTerminal {
    const trabajoTerminal = new TrabajoTerminal();

    for (const [key, value] of Object.entries(item)) {
      trabajoTerminal[key] = value;
    }
    return trabajoTerminal;
  }
}

export interface IConstanciaRetribucionSocial {
  retribucionSolcial?: RetribucionSocial;
  fechaInicio?: string;
  fechaFin?: string;
  institucion?: string;
  descripcion?: string;
}

export class ConstanciaRetribucionSocial implements IConstanciaRetribucionSocial {
  constructor(
    public retribucionSolcial?: RetribucionSocial,
    public fechaInicio?: string,
    public fechaFin?: string,
    public institucion?: string,
    public descripcion?: string
  ) {}

  static fromObject(item: IConstanciaRetribucionSocial): ConstanciaRetribucionSocial {
    const constancia = new ConstanciaRetribucionSocial();

    for (const [key, value] of Object.entries(item)) {
      constancia[key] = value;
    }
    return constancia;
  }
}

export interface ISustentoSolicitud {
  justificacion?: string;
  documento?: Documento | null;
}
export class SustentoSolicitud implements ISustentoSolicitud {
  public justificacion?: string;
  public documento?: Documento | null;
  constructor(init?: Partial<ISustentoSolicitud>) {
    Object.assign(this, init);
  }
}
